import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    continue: 'I changed my mind and want to continue opening my account',
    cta: 'Waiting...',
    description: 'We will contact you in a few moments.',
    incentive: '1 additional month offered for your participation',
    title: 'Thank you for taking part!',
  },

  fr: {
    continue: 'J’ai changé d’avis, continuer mon ouverture de compte',
    cta: 'En attente...',
    description:
      'Nous allons prendre contact avec vous dans quelques instants.',
    incentive:
      '1 mois d’abonnement supplémentaire vous est offert pour votre participation.',
    title: 'Merci de votre participation\u00a0!',
  },
} as const);

export default locales;
